import {
  HTTP_STATUS_BAD_GATEWAY_ERROR,
  HTTP_STATUS_BAD_REQUEST,
  HTTP_STATUS_FORBIDDEN,
  HTTP_STATUS_INTERNAL_SERVER_ERROR,
  HTTP_STATUS_NOT_FOUND,
  HTTP_STATUS_PAYMENT_REQUIRED,
  HTTP_STATUS_UNAUTHORIZED,
} from '../../../constants/api'
import { APP_STATUS_ERROR } from '../../../constants/common'

export const ERROR = {
  [APP_STATUS_ERROR]: {
    text: 'Error.SomethingWentWrongKey',
    title: 'Error.InternalAppErrorKey',
  },
  [HTTP_STATUS_BAD_GATEWAY_ERROR]: {
    text: 'Error.ServerEncounteredKey',
    title: 'Error.BadGatewayKey',
  },
  [HTTP_STATUS_BAD_REQUEST]: {
    text: 'Error.CheckPageAddressKey',
    title: 'Error.BadRequestKey',
  },
  [HTTP_STATUS_FORBIDDEN]: {
    text: 'Error.CheckPageAddressKey',
    title: 'Error.ForbiddenKey',
  },
  [HTTP_STATUS_INTERNAL_SERVER_ERROR]: {
    text: 'Error.ServerEncounteredKey',
    title: 'Error.InternalServerErrorKey',
  },
  [HTTP_STATUS_NOT_FOUND]: {
    text: 'Error.CheckPageAddressKey',
    title: 'Error.PageNotFoundKey',
  },
  [HTTP_STATUS_PAYMENT_REQUIRED]: {
    text: 'Error.CheckPageAddressKey',
    title: 'Error.PaymentRequiredKey',
  },
  [HTTP_STATUS_UNAUTHORIZED]: {
    text: 'Error.CheckPageAddressKey',
    title: 'Error.UnauthorizedKey',
  },
}
